import { Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { EditIcon, TrashIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import ButtonOutline from 'UiKit/button/buttonOutline';

import useOpenDeleteModal from 'View/brief-live/hooks/useOpenDeleteModal';
import { useBriefLiveState } from 'View/brief-live/state';

const ActionButton = ({ values, accessPermission }) => {
  const navigate = useNavigate();
  const { state } = useBriefLiveState();
  const { onOpenDeleteModal } = useOpenDeleteModal(state?.selectedTab);

  const itemId = values?.id;
  const navigateUpdate = state?.selectedTab === 'talkingPoint' ? `/brief-live/talking-point/upsert/${itemId}` : `/brief-live/giveaway/update/${itemId}`;

  return (
    <Flex gap="10px">
      <Condition statement={accessPermission?.isCanEdit}>
        <ButtonOutline borderWidth="1.5px" width="34px" height="34px" onClick={() => navigate(navigateUpdate)} data-testid={`brief-live-edit-${itemId}`}>
          <EditIcon color="var(--color-semantic-text)" />
        </ButtonOutline>
      </Condition>

      <Condition statement={accessPermission?.isCanDelete}>
        <ButtonOutline
          data-testid={`brief-live-delete-${itemId}`}
          borderWidth="1.5px"
          color="var(--color-error50)"
          width="34px"
          height="34px"
          onClick={() => onOpenDeleteModal(itemId, values)}
        >
          <TrashIcon color="var(--color-error50)" />
        </ButtonOutline>
      </Condition>
    </Flex>
  );
};

export default ActionButton;
